module.exports = __webpack_public_path__ + "media/images/creator/monitor/arrow-bfaa32c3699889f6df5f7a53e56179cb.svg";